"use client";

import type React from "react";
import { cn } from "@/lib/utils";

/**
 * A component that wraps the main content of the application,
 * automatically adjusting its left margin based on the state of the sidebar.
 * This prevents the fixed-position sidebar from overlapping the content.
 */
export default function MainPanel({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={cn(
        "flex flex-col flex-1 h-screen overflow-y-auto transition-all duration-300 ease-in-out",
      )}
    >
      {children}
    </div>
  );
}
